<script lang="ts" setup>
import type { IDividerProps } from "./VDivider.types";
import { computed } from "vue";

const MIN_THICKNESS = 1;

const props = withDefaults(defineProps<IDividerProps>(), {
  orientation: "horizontal",
  thickness: MIN_THICKNESS,
});

const sizeForStyles = computed(
  () => `${Math.max(props.thickness, MIN_THICKNESS)}px`,
);
</script>

<template>
  <hr
    :class="{
      'pl-divider': true,
      'pl-divider_vertical': orientation === 'vertical',
    }"
  />
</template>

<style scoped lang="postcss">
.pl-divider {
  margin: 0;
  background-color: var(--pl-divider-primary);
  border: none;
  height: v-bind(sizeForStyles);

  &_vertical {
    width: v-bind(sizeForStyles);
    height: 100%;
  }
}
</style>
